import {Component, ChangeDetectionStrategy} from '@angular/core';

import {Survey, SurveyRequest} from '../../../api/models/survey';
import {MessageService} from '../../../api/services/message.service';

import {SurveyService} from '../../../api/services/survey.service';
import {SurveyPropertiesComponent} from './steps/survey-properties/survey-properties.component';
import {UploadComponent} from './steps/upload/upload.component';
import {DialogRef} from "@angular/cdk/dialog";
import {WaButtonDirective, WaDialogDirective, WaIconDirective} from "angular-awesome";

@Component({
  selector: 'app-survey-create',
  templateUrl: './survey-create.component.html',
  styleUrls: ['./survey-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SurveyPropertiesComponent, UploadComponent, WaButtonDirective, WaDialogDirective, WaIconDirective]
})
export class SurveyCreateComponent {
  processing: boolean = false;
  properties: SurveyRequest | null = null;
  selectedFile: File | null = null;
  createdSurvey: Survey | null = null;

  constructor(private dialogRef: DialogRef<Survey, SurveyCreateComponent>,
              private msgService: MessageService,
              private surveyService: SurveyService) {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    const props = this.properties;
    const file = this.selectedFile;

    if (!props) return;
    this.createSurvey(props, file);
  }

  private async createSurvey(survey: SurveyRequest, file: File | null): Promise<void> {
    if (this.processing)
      return;

    this.setProcessing(true);

    try {

      if (!this.createdSurvey)
        this.createdSurvey = await this.surveyService.create(survey);

      else
        this.createdSurvey = await this.surveyService.update(this.createdSurvey.id, survey);

      const upload = file && await this.surveyService.upload(this.createdSurvey.id, file);
      this.createdSurvey = upload ? upload.survey : this.createdSurvey;
      this.dialogRef.close(this.createdSurvey);

    } catch (error: any) {

      const msg = error?.error?.detail || 'Could not create survey.'
      this.msgService.log(error);
      this.msgService.showSimple(msg);
    }

    this.setProcessing(false);
  }

  private setProcessing(processing: boolean): void {
    this.processing = processing;
  }

  private fileValid(): boolean {
    return !!this.selectedFile && this.selectedFile.type === 'application/json';
  }

  uploadValid() {
    const props = this.properties;
    if (!props)
      return false;
    return (props.name.length > 0) && this.fileValid()
  }
  createNewSurveyValid() {
    const props = this.properties;
    if (!props)
      return false;
    return props.name.length > 0;
  }
}
